import React, { useState } from "react";
import { Scan } from "../../vendorDashboardComponents/seatingDashboard/seatingDashboard/Scan";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { successAlert } from "../../../function/alert";

function QrScanGlobal(props) {
  const history = useHistory();
  const [openScan, setOpenScan] = useState(false);
  //   const openModalScan = (e) => setOpenScan(true);
  //   const closeModalScan = async (e) => {
  //     console.log("sadasda");
  //     await setOpenScan(!openScan);
  //   };
  // console.log(openScan);
  const onSuccessScan = (e) => {
    console.log(e);
    if (e?.diner_id) {
      history.push({ pathname: "/seatingdashboard", state: e });
    } else if (e?.order_id) {
      history.push({ pathname: "/orderdashboard/10", state: e });
    } else if (e.event_id) {
      history.push({ pathname: "/event", state: e });
    }else if (e?.expRequestId || e?.exp_id){
      history.push({pathname:"/experienceDashboard/all",state:{scanData:e}})
    }
  };
  return (
    <span onClick={() => setOpenScan(true)}>
      <Scan
        openModalScan={() => setOpenScan(true)}
        onCloseModal={() => setOpenScan(false)}
        open={openScan}
        sendData={props?.onboarding || {}}
        onSuccessScan={onSuccessScan}
        global
        mobile={props?.mobile}
      />
    </span>
  );
}

QrScanGlobal.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onboarding: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding?.restaurantDetails,
});

export default connect(mapStateToProps, {})(withRouter(QrScanGlobal));

// export default QrScanGlobal;
